

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class DocumentLine extends BaseEntity
{   
    public DocumentType: number; 
    public ItemCode: string; 
    public Description: string; 
    public Quantity: number; 
    public Price: number; 
    public TotalSum: number; 
    public Currency: string; 
    public Notes: string; 
    public IsOpen: boolean; 
	
}



